var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00065 0.666626C9.24128 0.666626 11.0688 2.43521 11.1635 4.65255L11.1673 4.83329V7.33329C12.548 7.33329 13.6673 8.45258 13.6673 9.83329V14.8333C13.6673 16.214 12.548 17.3333 11.1673 17.3333H2.83398C1.45327 17.3333 0.333984 16.214 0.333984 14.8333V9.83329C0.333984 8.45258 1.45327 7.33329 2.83398 7.33329V4.83329C2.83398 2.53211 4.69946 0.666626 7.00065 0.666626ZM11.1673 8.99996H2.83398C2.37375 8.99996 2.00065 9.37306 2.00065 9.83329V14.8333C2.00065 15.2935 2.37375 15.6666 2.83398 15.6666H11.1673C11.6276 15.6666 12.0007 15.2935 12.0007 14.8333V9.83329C12.0007 9.37306 11.6276 8.99996 11.1673 8.99996ZM7.14755 2.33754L7.00065 2.33329C5.66925 2.33329 4.58093 3.37406 4.5049 4.6864L4.50065 4.83329V7.33329H9.50065V4.83329C9.50065 3.50189 8.45988 2.41358 7.14755 2.33754L7.00065 2.33329L7.14755 2.33754Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/blockIcon.d3c2b521.svg";
export { ForwardRef as ReactComponent };